export const STEP_HOSE = 'Select Hose';
export const STEP_FITTING = 'Select Fittings';
export const STEP_ASS_LENGTH = 'Assembly Length';
export const STEP_ANGLE = 'Angle of Rotation';
export const STEP_ACCESSORIES = 'Accessories';
